(() => {
  const compactSizeDescription = (root, opener) => {
    const description = root.querySelector('.suedlis-mb-description');
    if (!description) return;
    const heading = [...description.querySelectorAll('h2, h3, h4')]
      .find((item) => item.textContent.trim().toLowerCase() === 'die richtige größe');
    const list = heading && heading.nextElementSibling;
    const measurement = list && list.nextElementSibling;
    if (!list || list.tagName !== 'UL' || !measurement || measurement.tagName !== 'P') return;
    const sizes = [...list.children].map((item) => item.textContent.replace(/\s+/g, ' ').trim());
    const expected = [
      /^S:\s*15\s*[–-]\s*17\s*cm Handgelenkumfang$/u,
      /^M:\s*17\s*[–-]\s*19\s*cm Handgelenkumfang$/u,
      /^L:\s*19\s*[–-]\s*21\s*cm Handgelenkumfang$/u,
      /^XL:\s*21\s*[–-]\s*23\s*cm Handgelenkumfang$/u
    ];
    if (sizes.length !== expected.length || !sizes.every((size, index) => expected[index].test(size))) return;
    if (!/^Miss dein Handgelenk (?:eng )?anliegend/.test(measurement.textContent.trim())) return;
    const link = opener.cloneNode(true);
    link.textContent = 'Wie messe ich meinen Handgelenkumfang? →';
    const paragraph = document.createElement('p');
    paragraph.append(link);
    heading.textContent = 'Handgelenkumfang & Passform';
    measurement.textContent = 'Miss deinen tatsächlichen Handgelenkumfang ohne Zugabe an der Tragestelle. Wähle danach oben bewusst, ob dein Meerbegleiter normal, angenehm oder locker sitzen soll.';
    list.remove();
    measurement.after(paragraph);
  };

  const initialize = (scope) => {
    scope.querySelectorAll('[data-suedlis-mb-size-guide]').forEach((dialog) => {
      if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
      const root = dialog.closest('.suedlis-mb-product');
      const opener = root && root.querySelector('[data-suedlis-size-guide-open]');
      const close = dialog.querySelector('[data-suedlis-size-guide-close]');
      const content = dialog.querySelector('[data-suedlis-size-guide-content]');
      if (!root || !opener || !close || !content) return;
      dialog.dataset.initialized = 'true';
      compactSizeDescription(root, opener);
      let returnFocus = null;
      let pointerStartedOutside = false;
      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-suedlis-size-guide-open]');
        if (!trigger || !root.contains(trigger) || trigger.getAttribute('aria-controls') !== dialog.id) return;
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (dialog.open) return;
        returnFocus = trigger;
        content.scrollTop = 0;
        dialog.showModal();
        document.documentElement.classList.add('suedlis-mb-size-guide-open');
        close.focus({preventScroll: true});
      });
      close.addEventListener('click', () => dialog.close());
      const outside = (event) => {
        const bounds = dialog.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      };
      dialog.addEventListener('pointerdown', (event) => { pointerStartedOutside = event.target === dialog && outside(event); });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog && pointerStartedOutside && outside(event)) dialog.close();
        pointerStartedOutside = false;
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = [close, content];
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('suedlis-mb-size-guide-open');
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll: true});
      });
      (root.closest('.shopify-section') || root).addEventListener('shopify:section:unload', () => { if (dialog.open) dialog.close(); });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
